const color1ConsoleLog = 'color: #1bb7a3; font-size: 16px'

export default color1ConsoleLog